module.exports = __webpack_public_path__ + "img/abstract2.3a696edc.png";